
import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

import LoginOrRedirect from "../components/Login/LoginOrRedirect";
import MetaReviewLogin from "../components/Login/MetaReviewLogin";
import Signup from "../components/Signup/Signup";
import AllProducts from "../components/Products/AllProducts";
import CheckoutPage from "../components/CheckoutPage/CheckoutPage";
import Licences from "../components/licences/licences";
import OrdersPage from "../components/Orders/OrdersPage";
import TravelServices from "../components/Travel/View/TravelServices";
import MyTravelManager from "../components/Travel/View/MyTravelManager";
import ProfilePage from "../components/Profile/ProfilePage";
import SettingsPage from "../components/settings/SettingsPage";
import FlightBookings from "../components/TravelOrders/FlightsBookings/FlightBookings";
import FlightCheckout from "../components/TravelOrders/FlightsBookings/FlightCheckout";
import MyProductsPage from "../components/Products/MyProductsPage";
import ProductDetailsPage from "../components/Products/ProductDetailsPage";
import AuthVerificationHandler from "../auth/AuthVerificationHandler";
import SearchDetailsPage from "../components/Search/SearchDetailsPage";
import FlightDetail from "../components/Travel/Flights/FlightDetail";
import BusDetail from "../components/Travel/Buses/BusDetail";
import AccommodationDetail from "../components/Travel/Accomodations/AccommodationDetail";
import OrderDetail from "../components/Orders/OrderDetail";
import DashboardLayout from "../components/Dashboard/DashboardLayout";
import ProductPage from "../components/Products/productPage";
import { HikeSearchTrips } from "../components/Travel/Hikes/hikeSearchTrips";
import { HikeCarsManager } from "../components/Travel/Hikes/HikeCarsManager";
import Locations from "../LocationsModule/Locations";
import CurrentLocationSaver from "../LocationsModule/CurrentLocationSaver";
import TripCheckoutPage from "../components/Travel/Hikes/TripCheckoutPage";
import BookingSuccessPage from "../components/Travel/Hikes/BookingSuccessPage";
import { RequestDelivery } from "../../src/deliveryModule/components/DeliveryRequestForm";
import { DeliveryList } from "../../src/deliveryModule/components/DeliveryList";
import { TrackDelivery } from "../../src/deliveryModule/components/TrackDelivery";
import DeliveryDetails from "../../src/deliveryModule/components/DeliveryDetails";
import DriverTrackerPage from "../../src/deliveryModule/components/Pages/DriverTrackerPage";
import CustomerTrackerPage from "../../src/deliveryModule/components/Directions/CustomerTrackerPage";
import LiveTripPage from "../../src/deliveryModule/components/RealTime/LiveTripPage";
import DriverSimulatorPage from "../../src/deliveryModule/components/Pages/DriverSimulatorPage";
import SimLitePage from "../../src/deliveryModule/components/Pages/SimLitePage";
import HomePage from "../components/HomePage/HomePage";
import DeliveryCheckoutPage from "../../src/deliveryModule/components/RealTime/DeliveryCheckoutPage";
import TermsAndConditions from "../components/Terms/TermsAndConditions";
import PrivacyPolicy from "../components/Terms/PrivacyPolicy";
import VinSearchPage from "../CarPartsModule/Pages/VINSearchPage";
import PartsCatalogPage from "../CarPartsModule/Pages/PartsCatalogPage";
import PartDetailsPage from "../CarPartsModule/Pages/PartDetailsPage";
import CheckoutSuccessPage from "../components/CheckoutPage/CheckoutSuccessPage";
import PartsExplorerPage from "../CarPartsModule/Pages/PartsExplorerPage";
import AdminOrdersPage from "../components/Orders/AdminOrdersPage";
import OrderTrackingPage from "../components/Orders/OrderTrackingPage";
import DeliveryAddressPage from "../../src/deliveryModule/components/DeliveryAddressPage";
import CheckoutPendingPage from "../components/CheckoutPage/CheckoutPendingPage";
import Cars from "../components/Travel/Cars/Cars";
import Accommodations from "../components/Travel/Accomodations/Accommodations";
import CarHireCheckoutPage from "../components/Travel/Cars/CarHireCheckoutPage";
import AccommodationCheckoutPage from "../components/Travel/Accomodations/AccommodationCheckoutPage";
import AdminAccommodationBookings from "../components/Travel/Accomodations/AdminAccommodationBookings";
import AdminCarMaintenance from "../components/Travel/Cars/AdminCarMaintenance";
import MyHireBookings from "../components/Travel/Cars/MyHireBookings";
import OwnerHireDashboard from "../components/Travel/Cars/OwnerHireDashboard";
import HireManagerTabsPage from "../components/Travel/Cars/HireManagerTabsPage";
import ApplicationAnalyticsDashboard from "../components/Analytics/ApplicationAnalyticsDashboard";
import ProductAdminPage from "../components/Products/ProductAdminPage";
import CategoryProductsPage from "../components/Products/Category/CategoryProductsPage";
import ExplorePage from "../components/Explore/ExplorePage";
import ManagePage from "../components/Manage/ManagePage";
import AccountHubPage from "../components/Account/AccountHubPage";
import CarDetailPage from "../components/Travel/Cars/CarDetailPage";
import HikeDetailsPage from "../components/Travel/Hikes/HikeDetailsPage";
import NotificationsPage from "../components/Notification/NotificationsPage";
import WhatsappCheckoutPage from "../components/CheckoutPage/WhatsappCheckoutPage";
import SupportTicketsPage from "../components/Support/SupportTicketsPage";
import SupportTicketDetailsPage from "../components/Support/SupportTicketDetailsPage";
import CompletePhone from "../components/Login/CompletePhone";
import AdminFinanceHubPage from "../components/Finance/AdminFinanceHubPage";
import AdminFinanceOverviewPage from "../components/Finance/AdminFinanceOverviewPage";
import AdminSellerFinancePage from "../components/Finance/AdminSellerFinancePage";
import DriverFinanceDashboard from "../components/Finance/DriverFinanceDashboard";
import SellerFinanceDashboard from "../components/Finance/SellerFinanceDashboard";
import AdminDriverEarningsPage from "../components/Finance/AdminDriverEarningsPage";
import AdminPaymentsPage from "../components/Finance/AdminPaymentsPage";
import AdminPayoutBatchDetailsPage from "../components/Finance/AdminPayoutBatchDetailsPage";
import AdminPayoutBatchesPage from "../components/Finance/AdminPayoutBatchesPage";
import AdminSalesAllocationsPage from "../components/Finance/AdminSalesAllocationsPage";
import AdminPayoutDestinationsPage from "../components/Finance/AdminPayoutDestinationsPage";
import AdminLedgerAuditPage from "../components/Finance/AdminLedgerAuditPage";
import DispatchQueuePage from "../components/DriverAdmin/DispatchQueuePage";
import DriverModuleHubPage from "../components/DriverAdmin/DriverModuleHubPage";
import DriverLiveMapPage from "../components/DriverAdmin/DriverLiveMapPage";
import DriversPage from "../components/DriverAdmin/DriversPage";
import WarehouseAssignmentsPage from "../components/DriverAdmin/WarehouseAssignmentsPage";
import DriverAssignmentPage from "../components/DriverAdmin/DriverAssignmentPage";
import PinManagementPage from "../components/Pins/PinManagementPage";
import PinVerificationPage from "../components/Pins/PinVerificationPage";
import BusinessDetailsPage from "../components/Businesses/BusinessDetailsPage";
import WhatsAppCompleteProfilePage from "../auth/WhatsappAuth/WhatsAppCompleteProfilePage";
import WaybillDispatchPage from "../components/Waybills/WaybillDispatchPage";
import InventoryAdminPage from "../InventoryStockModule/InventoryAdminPage";
import AiStudioSmokeTestPage from "../AiModule/social/components/AiStudioSmokeTestPage";
import MetaReviewCallback from "../components/MetaReview/MetaReviewCallback";
import MetaReviewDashboard from "../components/MetaReview/MetaReviewDashboard";
import AccommodationGuestCheckInPage from "../components/Travel/Accomodations/AccommodationGuestCheckInPage";
import MarketplaceSyncPage from "../AiModule/AiMarketPlaceSync/MarketplaceSyncPage";
import UsersAdminPage from "../components/Profile/UsersAdminPage";
import GlobalSpinner from "../components/CustomReusables/GlobalSpinner";
import { db } from "../configs/firebase";
import {
  normalizeUserRole,
  USER_ROLES,
} from "../components/Profile/constants/userRoles";
import { capturePickDenguChannel } from "../utils/whatsappChannel";
import OrderVerificationPage from "../components/OrderVerification/OrderVerificationPage";
import SuperAdminCareersRoute from "../components/Careers/SuperAdminCareersRoute";
import CareersPage from "../components/Careers/CareersPage";
import PublicLayout from "../components/Layout/PublicLayout";
import ScrollToTopOnNavigate from "../utils/ScrollToTopOnNavigate";


// New shared public layout.
// All other imports and existing functionality remain unchanged.


const SuperAdminUsersRoute = () => {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const [redirectPath, setRedirectPath] = useState("/login");

  useEffect(() => {
    let active = true;

    const unsubscribe = onAuthStateChanged(
      getAuth(),
      async (currentUser) => {
        if (!active) return;

        if (!currentUser) {
          setAllowed(false);
          setRedirectPath("/login");
          setLoading(false);
          return;
        }

        try {
          const userSnapshot = await getDoc(
            doc(db, "users", currentUser.uid)
          );

          const role = userSnapshot.exists()
            ? normalizeUserRole(userSnapshot.data().role)
            : USER_ROLES.GUEST;

          if (!active) return;

          setAllowed(role === USER_ROLES.SUPER_ADMIN);
          setRedirectPath("/dashboard");
        } catch (error) {
          console.error(
            "Failed to verify Super Admin access:",
            error
          );

          if (!active) return;

          setAllowed(false);
          setRedirectPath("/dashboard");
        } finally {
          if (active) {
            setLoading(false);
          }
        }
      }
    );

    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "240px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <GlobalSpinner />
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return <UsersAdminPage />;
};

const WhatsAppInvoiceRedirect = () => {
  const { orderId } = useParams<{ orderId: string }>();

  if (!orderId) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/invoice/${orderId}`} replace />;
};

const WhatsAppOrderRedirect = () => {
  const { orderId } = useParams<{ orderId: string }>();

  if (!orderId) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/orders/${orderId}`} replace />;
};

const WhatsAppChannelCapture = () => {
  const location = useLocation();

  useEffect(() => {
    capturePickDenguChannel({
      pathname: location.pathname,
      search: location.search,
    });
  }, [location.pathname, location.search]);

  return null;
};

const AppRoutes = () => (
  <>
    <WhatsAppChannelCapture />
    <ScrollToTopOnNavigate />

    <Routes>
      {/*
       * EXISTING DASHBOARD SHELL
       *
       * Kept separate from PublicLayout.
       * No public footer is rendered for these routes.
       * All existing children and guards remain intact.
       */}
      <Route path="/" element={<DashboardLayout />}>
        <Route index element={<HomePage />} />
        <Route path="dashboard" element={<HomePage />} />
        <Route path="search-trip" element={<HomePage />} />
        <Route path="explore" element={<ExplorePage />} />
        <Route path="manage" element={<ManagePage />} />
        <Route path="account" element={<AccountHubPage />} />

        <Route
          path="shop/category/:categorySlug"
          element={<CategoryProductsPage />}
        />

        <Route path="shop" element={<ProductPage />} />
        <Route path="checkout" element={<CheckoutPage />} />
        <Route path="licences" element={<Licences />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="travel" element={<TravelServices />} />

        <Route path="hike" element={<HikeSearchTrips />} />
        <Route
          path="hike/checkout/:tripId"
          element={<TripCheckoutPage />}
        />
        <Route path="hikes/:id" element={<HikeDetailsPage />} />
        <Route path="travel/hikes/:id" element={<HikeDetailsPage />} />
        <Route path="notifications" element={<NotificationsPage />} />

        <Route path="hike-manager" element={<HikeCarsManager />} />
        <Route
          path="booking-success/:bookingId"
          element={<BookingSuccessPage />}
        />

        <Route path="travel-manager" element={<MyTravelManager />} />
        <Route path="locations" element={<Locations />} />
        <Route path="maps" element={<CurrentLocationSaver />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="settings" element={<SettingsPage />} />

        {/* Existing Super Admin users guard */}
        <Route
          path="admin/users"
          element={<SuperAdminUsersRoute />}
        />

        {/* Protected Careers administration */}
        <Route
          path="admin/careers"
          element={<SuperAdminCareersRoute />}
        />

        <Route
          path="flight-booking/:flightId"
          element={<FlightBookings />}
        />

        <Route
          path="flights/checkout"
          element={<FlightCheckout />}
        />

        <Route path="my-products" element={<MyProductsPage />} />
        <Route path="farming" element={<Licences />} />
        <Route path="food" element={<Licences />} />
        <Route path="tickets" element={<Licences />} />
        <Route path="experiences" element={<Licences />} />
        <Route
          path="product/:id"
          element={<ProductDetailsPage />}
        />

        <Route
          path="manage/products"
          element={<ProductAdminPage />}
        />

        <Route
          path="delivery/request"
          element={<RequestDelivery />}
        />

        <Route
          path="delivery/list"
          element={<DeliveryList />}
        />

        <Route
          path="delivery/track/:deliveryId"
          element={<TrackDelivery />}
        />

        <Route
          path="delivery/:deliveryId"
          element={<DeliveryDetails />}
        />

        <Route
          path="delivery-checkout"
          element={<DeliveryCheckoutPage />}
        />

        <Route
          path="driver-tracker/:deliveryId"
          element={<DriverTrackerPage />}
        />

        <Route
          path="driver-sim/:deliveryId"
          element={<DriverSimulatorPage />}
        />

        <Route
          path="customer-tracker/:deliveryId"
          element={<CustomerTrackerPage />}
        />

        <Route
          path="live-trip/:deliveryId"
          element={<LiveTripPage />}
        />

        <Route
          path="driver-sim-lite/:deliveryId"
          element={<SimLitePage />}
        />

        <Route
          path="delivery/address"
          element={<DeliveryAddressPage />}
        />

        <Route path="hire/cars" element={<Cars />} />
        <Route
          path="car-hire-checkout"
          element={<CarHireCheckoutPage />}
        />
        <Route
          path="travel/cars/:id"
          element={<CarDetailPage />}
        />
        <Route
          path="hire-manager"
          element={<HireManagerTabsPage />}
        />

        <Route
          path="travel/car-maintenance"
          element={<AdminCarMaintenance />}
        />

        <Route
          path="travel/my-hire-bookings"
          element={<MyHireBookings />}
        />

        <Route
          path="travel/owner-hire-dashboard"
          element={<OwnerHireDashboard />}
        />

        <Route
          path="travel/accommodations/checkout/:id"
          element={<AccommodationCheckoutPage />}
        />

        <Route
          path="book/accommodation"
          element={<Accommodations />}
        />

        <Route
          path="travel/accommodations/:id"
          element={<AccommodationDetail />}
        />

        <Route
          path="travel/Accommodation-manager"
          element={<AdminAccommodationBookings />}
        />

        <Route
          path="travel/accommodation-manager"
          element={<AdminAccommodationBookings />}
        />

        <Route
          path="search-details/:type/:id"
          element={<SearchDetailsPage />}
        />

        <Route
          path="search-details/flights/:id"
          element={<FlightDetail />}
        />

        <Route
          path="search-details/buses/:id"
          element={<BusDetail />}
        />

        <Route
          path="search-details/hikes/:id"
          element={<HikeDetailsPage />}
        />

        <Route
          path="search-details/orders/:id"
          element={<OrderDetail />}
        />

        <Route
          path="search-details/cars/:id"
          element={<CarDetailPage />}
        />

        <Route
          path="search-details/accommodations/:id"
          element={<AccommodationDetail />}
        />

        <Route path="parts" element={<PartsExplorerPage />} />
        <Route
          path="parts/vin-search"
          element={<VinSearchPage />}
        />

        <Route
          path="parts/catalog"
          element={<PartsCatalogPage />}
        />

        <Route
          path="parts/:id"
          element={<PartDetailsPage />}
        />

        <Route
          path="checkout-success/:orderId"
          element={<CheckoutSuccessPage />}
        />

        <Route
          path="checkout-pending/:orderId"
          element={<CheckoutPendingPage />}
        />

        <Route
          path="/whatsapp/checkout/:orderId"
          element={<WhatsappCheckoutPage />}
        />

        <Route
          path="admin/orders"
          element={<AdminOrdersPage />}
        />

        <Route
          path="analytics"
          element={<ApplicationAnalyticsDashboard />}
        />

        <Route
          path="/support/tickets"
          element={<SupportTicketsPage />}
        />

        <Route
          path="/support/tickets/:id"
          element={<SupportTicketDetailsPage />}
        />

        <Route
          path="finance/admin"
          element={<AdminFinanceHubPage />}
        />

        <Route
          path="finance/admin/overview"
          element={<AdminFinanceOverviewPage />}
        />

        <Route
          path="finance/admin/seller/:sellerUserId"
          element={<AdminSellerFinancePage />}
        />

        <Route
          path="finance/seller"
          element={<SellerFinanceDashboard />}
        />

        <Route
          path="finance/driver"
          element={<DriverFinanceDashboard />}
        />

        <Route
          path="finance/admin/payments"
          element={<AdminPaymentsPage />}
        />

        <Route
          path="finance/admin/sales"
          element={<AdminSalesAllocationsPage />}
        />

        <Route
          path="finance/admin/driver-earnings"
          element={<AdminDriverEarningsPage />}
        />

        <Route
          path="finance/admin/batches"
          element={<AdminPayoutBatchesPage />}
        />

        <Route
          path="finance/admin/batches/:batchId"
          element={<AdminPayoutBatchDetailsPage />}
        />

        <Route
          path="finance/admin/payout-destinations"
          element={<AdminPayoutDestinationsPage />}
        />

        <Route
          path="finance/admin/ledger"
          element={<AdminLedgerAuditPage />}
        />

        <Route
          path="drivers/admin"
          element={<DriverModuleHubPage />}
        />

        <Route
          path="drivers/admin/live-map"
          element={<DriverLiveMapPage />}
        />

        <Route
          path="drivers/admin/list"
          element={<DriversPage />}
        />

        <Route
          path="drivers/admin/assignments"
          element={<WarehouseAssignmentsPage />}
        />

        <Route
          path="drivers/admin/dispatch"
          element={<DispatchQueuePage />}
        />

        <Route
          path="/pins/manage"
          element={<PinManagementPage />}
        />

        <Route
          path="/pins/verify"
          element={<PinVerificationPage />}
        />

        <Route
          path="/drivers/assignments"
          element={<DriverAssignmentPage />}
        />

        <Route
          path="/whatsapp-complete-profile"
          element={<WhatsAppCompleteProfilePage />}
        />

        <Route
          path="/drivers/admin/waybills"
          element={<WaybillDispatchPage />}
        />

        <Route
          path="manage/inventory"
          element={<InventoryAdminPage />}
        />

        <Route
          path="admin/ai-studio-test"
          element={<AiStudioSmokeTestPage />}
        />
      </Route>

      {/*
       * PUBLIC / STANDALONE ROUTES
       *
       * Everything below is outside the DashboardLayout
       * and shares the same PublicLayout + PublicFooter.
       *
       * All original paths and page components are retained.
       */}
      <Route element={<PublicLayout />}>
        <Route
          path="/verify-reset"
          element={<AuthVerificationHandler />}
        />

        <Route
          path="/login"
          element={<LoginOrRedirect />}
        />

        <Route
          path="/meta-review"
          element={<MetaReviewLogin />}
        />

        <Route
          path="/meta-review/callback"
          element={<MetaReviewCallback />}
        />

        <Route
          path="/meta-review/dashboard"
          element={<MetaReviewDashboard />}
        />
        
    {/* Public Careers */}
<Route
  path="careers"
  element={<CareersPage mode="public" />}
/>

        <Route
          path="/signup"
          element={<Signup />}
        />

        <Route
          path="/terms"
          element={<TermsAndConditions />}
        />

        <Route
          path="/privacy"
          element={<PrivacyPolicy />}
        />

        <Route
          path="/track-order/:orderId"
          element={<OrderTrackingPage />}
        />

        <Route
          path="/orders/:id"
          element={<OrderDetail />}
        />

        <Route
          path="/invoice/:orderId"
          element={<CheckoutSuccessPage />}
        />

        <Route
          path="/whatsapp/action/invoice/:orderId"
          element={<WhatsAppInvoiceRedirect />}
        />

        <Route
          path="/whatsapp/action/:orderId"
          element={<WhatsAppOrderRedirect />}
        />

        <Route
          path="/whatsapp/action/seller/orders/:orderId"
          element={<WhatsAppOrderRedirect />}
        />

        <Route
          path="/complete-phone"
          element={<CompletePhone />}
        />

        <Route
          path="/search-details/businesses/:id"
          element={<BusinessDetailsPage />}
        />

        <Route
          path="book/accommodation/:bookingId"
          element={<AccommodationDetail />}
        />

        <Route
          path="products"
          element={<AllProducts />}
        />

        <Route
          path="book/accommodation/check-in/:bookingId"
          element={<AccommodationGuestCheckInPage />}
        />

        <Route
          path="/admin/marketplace-sync"
          element={<MarketplaceSyncPage />}
        />

        <Route
          path="/verify/:token"
          element={<OrderVerificationPage />}
        />
      </Route>
    </Routes>
  </>
);

export default AppRoutes;
